import { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import { eventApi } from "@/lib/eventHub";

/**
 * Persistent "TEST MODE" banner shown on every EventLayout page and inside the
 * admin/volunteer dashboards while `settings.test_mode` is true. Polls every
 * 60 s (matches follow-up worker cadence) so admins see status changes quickly.
 */
export default function TestModeBanner({ variant = "public" }) {
  const [on, setOn] = useState(false);
  useEffect(() => {
    let mounted = true;
    const tick = async () => {
      try {
        const { data } = await eventApi.config();
        if (mounted) setOn(!!data?.test_mode);
      } catch { /* noop */ }
    };
    tick();
    const t = setInterval(tick, 60_000);
    return () => { mounted = false; clearInterval(t); };
  }, []);
  if (!on) return null;

  const bg = variant === "admin"
    ? "bg-amber-400 text-amber-950 border-amber-500"
    : "bg-fuchsia-600 text-white border-fuchsia-700";
  return (
    <div
      data-testid="test-mode-banner"
      className={`sticky top-0 z-40 flex items-center justify-center gap-2 px-3 py-1.5 text-[10px] font-[Outfit] font-bold tracking-[0.28em] uppercase border-b ${bg}`}
    >
      <FlaskConical size={12} />
      Test Mode — Live attendee data & SMS is protected. All new records are tagged as test.
    </div>
  );
}
